import { capfirst } from 'journalize';

const getDivisionDisplay = contest =>
  `${capfirst(contest.division_type)} ${contest.district || ''}`.trim();

const getContestDisplay = contest => {
  if (contest.division_type === 'statewide') {
    return contest.office;
  }

  return `${contest.office}, ${getDivisionDisplay(contest)}`;
};

const createContestSlug = contest => {
  const parts = [contest.office_slug];

  if (contest.division_type !== 'statewide') {
    parts.push(`-${contest.district}`);
  }

  parts.push(`-${contest.party.slice(0, 3)}`);

  return parts.join('');
};

export { createContestSlug, getContestDisplay, getDivisionDisplay };



// WEBPACK FOOTER //
// ./election-utils.js